import { Link } from 'react-router-dom';
import React from 'react'
import config from '../../../config'
import '../../Pages/css/footer.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FaTelegramPlane, FaLinkedinIn, FaYoutube, FaFacebook, FaInstagram, FaDiscord, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";


const Footer = (bg) => {
    // console.log('bg',bg.bg)
    return (<>
        <footer className={`pt-4 pb-4 ${bg.bg} position-relative bg-white`}>
            <Container className='pt-4 border-top border-primary'>

                <Row>
                    <Col lg={8}>
                        <div className='footer-block '>
                            <ul>
                                <li><a href={`${config.baseurl}Aboutus`} target="_blank" className='text-decoration-none '>About Us</a></li>
                                <li><a href={`${config.baseurl}Privacypolicy`} target="_blank" className='text-decoration-none '>Privacy Policy</a></li>
                                <li><a href="#FAQ"target="_blank" className='text-decoration-none '>FAQ</a></li>
                                <li><a href={`${config.baseurl}blog`} target="_blank" className='text-decoration-none '>Blog</a></li>

                                {/*  <li><a href='#' className='text-decoration-none '>Contact</a></li>
                                <li><a href='#' className='text-decoration-none '>Blog</a></li>
                                <li><a href='#' className='text-decoration-none '>Cookie Policy</a></li> */}
                            </ul>

                        </div>

                    </Col>
                    <Col lg={4} className='text-right'>
                        <div className='social-icon'>
                            <ul>
                            <li>
                                <a href='https://x.com/INFI_MultiChain'target='_blank' rel="noreferrer noopener">
                                        <FaXTwitter />
                                </a>
                            </li>
                            <li>
                                <a href='https://www.youtube.com/@INFIMultiChain'target='_blank' rel="noreferrer noopener">
                                        <span className='fs-5'><FaYoutube /></span>
                                    </a>
                            </li>
                            <li>
                                    <a href='https://t.me/InvertedInvestmentOfficialGroup'target='_blank' rel="noreferrer noopener">
                                        <span className='fs-5'><FaTelegramPlane/></span>
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.linkedin.com/showcase/infi-multichain-cdex/?viewAsMember=true' target='_blank' rel="noreferrer noopener">
                                        <span className='fs-5'><FaLinkedinIn /></span>
                                    </a>
                                </li>
                            </ul>

                        </div>
                    </Col>
                </Row>
                <Row className=''>
                    <Col lg={7} xs={12}>
                        <div className=''>
                            <a href='mailto:support@infimultichain.com' className='me-3 text-decoration-none  d-inline-block'>support@infimultichain.com</a>
                            {/* <span className='d-inline-block'>Audited by&nbsp;
                                <a href='https://solidproof.io/' className=''>
                                    <img src='assets/images/logo/solidproof.png' width="80px" />
                                </a>
                            </span> */}
                        </div>
                    </Col>
                    <Col lg={5} xs={12} className='copyright'>
                        <a href='#' className='text-decoration-none  '>© 2024 Infi Multichain. All rights reserved.</a>
                    </Col>
                </Row>
            </Container>
        </footer>
    </>
    )
}

export default Footer